import { LADDER_FORM as LABELS } from './labels.js';
import { validateNumber } from '../../../../lib/validate';

function validateIsPositiveNumber(rule, value, callback) {
  if (!validateNumber(value)) {
    callback(new Error(`${LABELS.pleaseEnter} ${LABELS.numberGreater.replace('?', '0')}`));
  } else {
    callback();
  }
}

export default {
  form: {
    ladderQuantity: ''
  },
  option: {
    menuSpan: 12,
    submitText: LABELS.add,
    column: [
      {
        span: 12,
        label: LABELS.numberOfSteps,
        prop: 'ladderQuantity',
        datatype: 'number',
        type: 'number',
        rules: [
          {
            required: true,
            message: `${LABELS.pleaseEnter} ${LABELS.numberOfSteps}`,
            trigger: 'blur',
            type: 'number'
          },
          { trigger: 'change', validator: validateIsPositiveNumber }
        ]
      }
    ]
  }
};
